import React from "react";
import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import { FourColGrid } from "./four-col-grid";
import {
  ArrowElevenStories,
  ArrowFourColGrid,
  ArrowFourColTwelveStories,
  ArrowFullScreenSlider,
  ArrowOneColStoryList,
  ArrowThreeColGrid,
  ArrowThreeColSevenStories,
  ArrowTwoColFourStories,
  ArrowAFourColPortraitStories,
} from "./arrow-rows";
import { ColorThemeLayout } from "../../arrow/components/Rows/color-theme-layout";
import { OneBigSixSmall } from "../../arrow/components/Rows/OneBigSixSmall";
import { OneRowFiveColsRect } from "../../arrow/components/Rows/OneRowFiveColsRect";
import { OneRowFiveColsVertical } from "../../arrow/components/Rows/OneRowFiveColsVertical";
import { OneRowFiveColsSquare } from "../../arrow/components/Rows/OneRowFiveColsSquare";
import { CollectionOnlyLayout } from "../../arrow/components/Rows/CollectonOnlyLayout";
import { StoryImageForGenretLayout } from "../../arrow/components/Rows/StoryImageForGenretLayout";
import { StoryImageForSectionLayout } from "../../arrow/components/Rows/StoryImageForSectionLayout";
import { OneBigThreeSmallSectionLayout } from "../../arrow/components/Rows/OneBigThreeSmallSectionLayout";
import { Hero1Layout } from "../../arrow/components/Rows/Hero1Layout";
import UserMediaHistory from "../layouts/user-media-history";
import UserMediaFavourites from "../layouts/user-media-favourites";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { getCollectionitems } from "../../../api/utils";
import { useState } from "react";
import { useEffect } from "react";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
    const qtState = useSelector((state) => get(state, ["qt"], {}));
    const currentPath = get(qtState, ["currentPath"], "");

    const currentCollectionSlug = props?.collection?.slug || null;
    const isAdSlug = currentCollectionSlug?.startsWith("ad-");
    const [evaluatedAdHtml, setEvaluatedAdHtml] = useState(null);
    useEffect(() => {
      const fetchData = async () => {
        if (!isAdSlug) return;

        try {
          const resultItem = await getCollectionitems(currentCollectionSlug, 0, 1);
          const adText = resultItem?.[0]?.story?.cards?.[0]?.["story-elements"]?.[0]?.text || "";

          if (adText) {
            const parser = new DOMParser();
            const decoded = parser.parseFromString(adText, "text/html");
            setEvaluatedAdHtml(decoded.documentElement.textContent || "");
          }
        } catch (err) {
          console.error("Error fetching ad content:", err);
        }
      };

      fetchData();
    }, [currentCollectionSlug, isAdSlug]);

    useEffect(() => {
      const scriptUrl = "https://static.elfsight.com/platform/platform.js";

      if (
        evaluatedAdHtml &&
        !document.querySelector(`script[src="${scriptUrl}"]`)
      ) {
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        document.body.appendChild(script);
      }
    }, [evaluatedAdHtml]);

    if (props.index === 0) {
      return (
        <>
          <EagerLoadImages predicate={(token) => token === "above-fold"}>
            {React.createElement(f, props)}
          </EagerLoadImages>
        </>
      );
    } else {
      return (
        <>
          {isAdSlug ? (
            evaluatedAdHtml ? (
              <div
                style={{ color: "white", marginTop: "30px" }}
                dangerouslySetInnerHTML={{ __html: evaluatedAdHtml }}
              />
              ) : null
          ) : (
            React.createElement(f, props)
          )}
          {props.index === 2 && (
            <>
              {(currentPath === "/" || currentPath === "/lammas") && (
                <>
                  <UserMediaHistory/>
                  <UserMediaFavourites qtConfig={qtConfig}/>
                </>
              )}
            </>
          )}
        </>
      );
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  FourColGrid: wrapEager(wrapCollectionLayout(FourColGrid)),
  ArrowFourColTwelveStories: wrapEager(wrapCollectionLayout(ArrowFourColTwelveStories)),
  ArrowThreeColGrid: wrapEager(wrapCollectionLayout(ArrowThreeColGrid)),
  ArrowFourColGrid: wrapEager(wrapCollectionLayout(ArrowFourColGrid)),
  ArrowElevenStories: wrapEager(wrapCollectionLayout(ArrowElevenStories)),
  ArrowTwoColFourStories: wrapEager(wrapCollectionLayout(ArrowTwoColFourStories)),
  ArrowFullScreenSlider: wrapEager(wrapCollectionLayout(ArrowFullScreenSlider)),
  ArrowOneColStoryList: wrapEager(wrapCollectionLayout(ArrowOneColStoryList)),
  ArrowThreeColSevenStories: wrapEager(wrapCollectionLayout(ArrowThreeColSevenStories)),
  ArrowAstroloryCollections: wrapEager(wrapCollectionLayout(ArrowAFourColPortraitStories)),
  ColorThemeLayout: wrapEager(wrapCollectionLayout(ColorThemeLayout)),
  OneBigSixSmall: wrapEager(wrapCollectionLayout(OneBigSixSmall)),
  OneBigThreeSmallSectionLayout: wrapEager(wrapCollectionLayout(OneBigThreeSmallSectionLayout)),
  OneRowFiveColsRect: wrapEager(wrapCollectionLayout(OneRowFiveColsRect)),
  OneRowFiveColsVertical: wrapEager(wrapCollectionLayout(OneRowFiveColsVertical)),
  OneRowFiveColsSquare: wrapEager(wrapCollectionLayout(OneRowFiveColsSquare)),
  CollectionOnlyLayout: wrapEager(wrapCollectionLayout(CollectionOnlyLayout)),
  StoryImageForSectionLayout: wrapEager(wrapCollectionLayout(StoryImageForSectionLayout)),
  Hero1Layout: wrapEager(wrapCollectionLayout(Hero1Layout)),
  defaultTemplate: wrapEager(wrapCollectionLayout(OneRowFiveColsSquare))
};
